import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import UnderConstruction from './UnderConstruction';

const pageStyle = {
    minHeight: 'calc(100vh - 180px)',
    backgroundColor: '#15171b',
    color: '#ffffff',
    padding: '60px 20px',
};

const containerStyle = {
    maxWidth: '760px',
    margin: '0 auto',
};

const headingStyle = {
    fontSize: '36px',
    fontWeight: '700',
    marginBottom: '12px',
};

const subheadingStyle = {
    fontSize: '18px',
    color: 'var(--highlight, #e9c548)',
    fontWeight: '600',
    marginBottom: '24px',
};

const bodyStyle = {
    fontSize: '15px',
    color: '#cccccc',
    lineHeight: '1.8',
    marginBottom: '20px',
};

const dividerStyle = {
    border: 'none',
    borderTop: '1px solid rgba(255,255,255,0.1)',
    margin: '36px 0',
};

const emailBlockStyle = {
    backgroundColor: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: '8px',
    padding: '28px 32px',
    textAlign: 'center',
};

const emailLabelStyle = {
    fontSize: '13px',
    color: '#aaaaaa',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: '10px',
};

const emailLinkStyle = {
    fontSize: '22px',
    fontWeight: '700',
    color: 'var(--highlight, #e9c548)',
    textDecoration: 'none',
    fontFamily: `var(--bodyfont) !important`
};

class Careers extends Component {
    render() {
        const appName = window.app && window.app.appName;
        if (appName !== 'screenixx') {
            return <UnderConstruction {...this.props} />;
        }

        return (
            <div className="info-page">
                <Header />
                <div style={pageStyle}>
                    <div style={containerStyle}>
                        <h1 style={headingStyle}>Careers at Screenixx</h1>
                        <p style={subheadingStyle}>Join the team shaping the future of streaming.</p>

                        <p style={bodyStyle}>
                            At Screenixx, we're building a platform where storytellers connect with audiences worldwide. We're always looking for passionate, talented individuals who love film, technology, and bold ideas.
                        </p>
                        <p style={bodyStyle}>
                            Whether you're in engineering, design, content, marketing, or operations — if you believe great stories deserve great platforms, we want to hear from you.
                        </p>

                        <hr style={dividerStyle} />

                        <h2 style={{ ...headingStyle, fontSize: '22px', marginBottom: '16px' }}>What We Look For</h2>
                        <ul style={{ ...bodyStyle, paddingLeft: '20px', fontFamily: `var(--bodyfont) !important` }}>
                            <li style={{ marginBottom: '10px' }}>A passion for storytelling and independent cinema</li>
                            <li style={{ marginBottom: '10px' }}>A collaborative mindset and drive to solve real problems</li>
                            <li style={{ marginBottom: '10px' }}>Curiosity, initiative, and a growth-oriented attitude</li>
                            <li style={{ marginBottom: '10px' }}>Commitment to inclusivity and diverse voices</li>
                        </ul>

                        <hr style={dividerStyle} />

                        <div style={emailBlockStyle}>
                            <p style={emailLabelStyle}>Send your resume and portfolio to</p>
                            <a href="mailto:careers@screenixx.com" style={emailLinkStyle}>
                                careers@screenixx.com
                            </a>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Careers;
